import { useEffect } from 'react';
import { useAtomValue } from 'jotai';
import { authUserMetaAtom, isRehydratingAtom } from '@/store/authAtoms';
import { selectedFacilityAtom } from '@/store/facilityAtom';
import { setRumUser, clearRumUser, setSiteGroupCode } from './datadog';
import { ddConfig } from './config';

/** FR-05: Syncs the authenticated user's opaque GUID to Datadog RUM. Clears on logout.
 *  Waits for isRehydratingAtom=false so we never tag RUM with a stale persisted identity
 *  that bootstrapAuth() may be about to invalidate. */
export function DatadogUserSync() {
  const user = useAtomValue(authUserMetaAtom);
  const isRehydrating = useAtomValue(isRehydratingAtom);
  useEffect(() => {
    if (!ddConfig.enabled || isRehydrating) return;
    if (user) setRumUser(user.id);
    else clearRumUser();
  }, [user, isRehydrating]);
  return null;
}

/** Keeps the Datadog RUM site_group_code context property in sync with the selected facility. */
export function DatadogFacilitySync() {
  const facility = useAtomValue(selectedFacilityAtom);
  useEffect(() => {
    if (!ddConfig.enabled) return;
    if (facility?.id) setSiteGroupCode(facility.id);
  }, [facility?.id]);
  return null;
}
